import { AAResponseMapper, ResponseError, } from "@finarkein/aasdk-core";
export class ResponseMapperNadl extends AAResponseMapper {
    constructor(response) {
        super(response);
    }
    async getResponse(operation) {
        // eslint-disable-next-line no-async-promise-executor
        return new Promise(async (resolve, reject) => {
            try {
                const response = await this.response;
                const { status, message, ...rest } = response;
                const responseObj = {
                    data: rest,
                    aaOperation: response.aaOperation,
                    aaOpAttempt: response.attempt,
                    aaErrorCode: response.errorCode,
                    aaMessage: response === null || response === void 0 ? void 0 : response.message,
                    status: response.status,
                };
                switch (operation) {
                    case "VALIDATE_USER":
                        this.handleValidateUser(response, responseObj);
                        break;
                    case "AA_LOGIN":
                        this.handleAALogin(response, responseObj);
                        break;
                    case "ACCOUNT_DISCOVERY":
                        this.handleAccountDiscovery(response, responseObj);
                        break;
                    case "LINKED_ACCOUNTS":
                    case "CONSENT_DETAILS":
                        this.handleLinkedAccountsOrConsentDetails(response, responseObj);
                        break;
                    case "ALT_MOBILE":
                        this.handleAltMobile(response, responseObj);
                        break;
                    case "CONFIRM_ALT_MOBILE":
                        this.handleConfirmAltMobile(response, responseObj);
                        break;
                    case "ACCOUNT_LINKING":
                        this.handleAccountLinking(response, responseObj);
                        break;
                    case "CONFIRM_ACCOUNT_LINKING":
                        this.handleConfirmAccountLinking(response, responseObj);
                        break;
                    case "CONSENT_ACTION":
                        this.handleConsentAction(response, responseObj);
                        break;
                    case "USER_INFO":
                        this.handleUserInfo(response, responseObj);
                        break;
                    case "LOGOUT":
                        this.handleLogout(response, responseObj);
                        break;
                    default:
                        reject(new ResponseError("UNKNOWN_OPERATION", responseObj, "Unknown operation type"));
                }
                if (responseObj.status !== "SUCCESS") {
                    reject(new ResponseError(`${responseObj.status}`, responseObj, response.message || responseObj.message || ""));
                }
                resolve(responseObj);
            }
            catch (e) {
                reject(e);
            }
        });
    }
    handleValidateUser(response, responseObj) {
        if (response.statusCode === 200) {
            responseObj.status = "SUCCESS";
        }
        else if (response.statusCode === 400) {
            if (response.errorCode === 603) {
                // bad request - we can't do anything
                responseObj.status = "BAD_REQUEST";
                responseObj.message = "Invalid VUA";
            }
            else if (response.errorCode === 8024) {
                // some weird error Cannot decrypt. Deployments in progress. Please check after some time
                // switch AA
                responseObj.status = "FAILURE";
                responseObj.message = "Some error occurred, please try again after some time";
            }
            else if (response.errorCode === 51) {
                ///bad request - we can't do anything
                responseObj.status = "BAD_REQUEST";
                responseObj.message = "Invalid format of VUA";
            }
            else if (response.errorCode === 7006 || response.errorCode === 8023) {
                // some failure occurred , not in our hands
                responseObj.status = "FAILURE";
                responseObj.message = "For security reasons, we have limited the number of times you can generate OTP. Please try after 5 minutes";
            }
            else if (response.errorCode === 8000) {
                responseObj.status = "SESSION_ERROR";
                responseObj.message = "Session Timed Out. Please restart the journey";
            }
        }
        else if (response.statusCode === 404 && response.errorCode === 235) {
            responseObj.status = "FAILURE";
            responseObj.message = "Some network error occured. Please try again later";
        }
        else if (response.statusCode === 500 && response.errorCode === 500) {
            responseObj.status = "UNKNOWN_ERROR";
            responseObj.message = "Some error occurred, please try again after some time";
        }
    }
    handleAALogin(response, responseObj) {
        var _a, _b, _c, _d;
        if (response.statusCode === 200) {
            responseObj.status = "SUCCESS";
        }
        else if (response.statusCode === 400) {
            if (response.errorCode === 4000) {
                //confrim: - Account has been blocked
                responseObj.status = "FAILURE";
                responseObj.message = "Some error occurred, please try again after some time";
            }
            else if (response.errorCode === 227) {
                responseObj.status = "RETRY";
                responseObj.message = "Otp Verfication Failed";
            }
            else if (response.errorCode === 608) {
                responseObj.status = "RECORD_NOT_FOUND";
                responseObj.message = "MobileNo validation Failed";
            }
            else if (response.errorCode === 8000) {
                responseObj.status = "SESSION_ERROR";
                responseObj.message = "Session Timed Out. Please restart the journey";
            }
            else if (response.errorCode === 131) {
                if ((_b = (_a = response === null || response === void 0 ? void 0 : response.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.errors) {
                    const errors = (_d = (_c = response === null || response === void 0 ? void 0 : response.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.errors;
                    errors.forEach((element) => {
                        if (element.code === 600) {
                            responseObj.status = "BAD_REQUEST";
                            responseObj.message = "An account exists with this number";
                        }
                        else if (element.code === 604) {
                            responseObj.status = "BAD_REQUEST";
                            responseObj.message = "Invalid Mobile Number";
                        }
                        else if (element.code === 690) {
                            responseObj.status = "BAD_REQUEST";
                            responseObj.message = "VUA already taken";
                        }
                    });
                }
            }
            else if (response.errorCode === 226) {
                //confirm this
                responseObj.status = "BAD_REQUEST";
                responseObj.message = "Invalid Mobile validation Id";
            }
            else if (response.errorCode === 7006 || response.errorCode === 8023) {
                // some failure occurred , not in our hands
                responseObj.status = "FAILURE";
                responseObj.message = "For security reasons, we have limited the number of times you can generate OTP. Please try after 5 minutes";
            }
        }
        else if (response.statusCode === 500 && response.errorCode === 500) {
            responseObj.status = "UNKNOWN_ERROR";
            responseObj.message = "Some error occurred, please try again after some time";
        }
    }
    handleAccountDiscovery(response, responseObj) {
        if (response.statusCode === 201 || response.statusCode === 200) {
            responseObj.status = "SUCCESS";
        }
        else if (response.statusCode === 400) {
            switch (response.errorCode) {
                case 2883:
                case 9055:
                    responseObj.status = "RETRY";
                    responseObj.message = "Account Discovery Failed";
                    break;
                case 2458:
                    responseObj.status = "BAD_REQUEST";
                    responseObj.message = "Invalid mobile identifier value";
                    break;
                case 8000:
                    responseObj.status = "SESSION_ERROR";
                    responseObj.message = "Session Timed Out. Please restart the journey";
                    break;
            }
        }
        else if (response.statusCode === 401 || response.statusCode === 403) {
            if (response.errorCode === 401 || response.errorCode === 5000) {
                responseObj.status = "SESSION_ERROR";
                responseObj.message = "Session Timed Out. Please restart the journey";
            }
        }
        else if (response.statusCode === 500 && response.errorCode === 500) {
            responseObj.status = "UNKNOWN_ERROR";
            responseObj.message = "Some error occurred, please try again after some time";
        }
        else if (response.statusCode === 404) {
            if (response.errorCode === 2331 || response.errorCode === 3002) {
                responseObj.status = "BAD_REQUEST";
                responseObj.message = "Invalid Request";
            }
            else if (`${response.errorCode}` === "FIP_UNAVAILABLE") {
                responseObj.status = "FIP_UNAVAILABLE";
                responseObj.message = "Fip is unavailable";
            }
        }
    }
    handleLinkedAccountsOrConsentDetails(response, responseObj) {
        if (response.statusCode === 200) {
            responseObj.status = "SUCCESS";
        }
        else if (response.statusCode === 400) {
            if (response.errorCode === 8000) {
                responseObj.status = "SESSION_ERROR";
                responseObj.message = "Session Timed Out. Please restart the journey";
            }
        }
        else if (response.statusCode === 500) {
            if (response.errorCode === 500) {
                responseObj.status = "UNKNOWN_ERROR";
                responseObj.message = "Some error occurred, please try again after some time";
            }
        }
    }
    handleConfirmAltMobile(response, responseObj) {
        if (response.statusCode === 200) {
            responseObj.status = "SUCCESS";
            responseObj.data = response.data;
        }
        else if (response.statusCode === 400) {
            switch (response.errorCode) {
                case 226:
                    //confirm this
                    responseObj.status = "BAD_REQUEST";
                    responseObj.message = "Invalid Mobile validation Id";
                    break;
                case 227:
                    responseObj.status = "RETRY";
                    responseObj.message = "Otp Verfication Failed";
                    break;
                case 8000:
                    responseObj.status = "SESSION_ERROR";
                    responseObj.message = "Session Timed Out. Please restart the journey";
                    break;
            }
        }
        else if (response.statusCode === 500) {
            if (response.errorCode === 500) {
                responseObj.status = "UNKNOWN_ERROR";
                responseObj.message = "Some error occurred, please try again after some time";
            }
        }
    }
    handleAltMobile(response, responseObj) {
        if (response.statusCode === 200) {
            responseObj.status = "SUCCESS";
        }
        else if (response.statusCode === 400) {
            switch (response.errorCode) {
                case 236:
                    //confirm this - retriable error
                    //responseObj.status = 'FAILURE';
                    responseObj.status = "RETRY";
                    responseObj.message = "Failed to send notification"; //retry after 2-3 sec total - 10sec - failure
                    break;
                case 234:
                    responseObj.status = "BAD_REQUEST";
                    responseObj.message = "Invalid mobile number";
                    break;
                case 8000:
                    responseObj.status = "SESSION_ERROR";
                    responseObj.message = "Session Timed Out. Please restart the journey";
                    break;
            }
        }
    }
    handleAccountLinking(response, responseObj) {
        if (response.statusCode === 200 || response.statusCode === 201) {
            responseObj.status = "SUCCESS";
        }
        else if (response.statusCode === 400) {
            switch (response.errorCode) {
                case 2330:
                    //Failed to get fip server response , confirm this FIP server error : TODO : please check
                    //responseObj.status = 'UNKNOWN_ERROR';
                    responseObj.status = "FAILURE";
                    responseObj.message = "Some error occurred, please try again after some time";
                    break;
                case 2884:
                    // account link - confirm this TODO: retry 3
                    responseObj.status = "BAD_REQUEST";
                    responseObj.message = "Failed to link account";
                    break;
                case 2339:
                    // account link - confirm this - : TODO : handle later on!!
                    responseObj.status = "FAILURE";
                    responseObj.message = "Account already linked";
                    break;
                case 8000:
                    responseObj.status = "SESSION_ERROR";
                    responseObj.message = "Session Timed Out. Please restart the journey";
                    break;
            }
        }
        else if (response.statusCode === 500) {
            if (response.errorCode === 500) {
                responseObj.status = "FAILURE";
                responseObj.message = "Some error occurred, please try again after some time";
            }
        }
        else if (response.statusCode === 401 || response.statusCode === 403 || response.statusCode === 500) {
            if (response.errorCode === 401 || response.errorCode === 5000) {
                responseObj.status = "SESSION_ERROR";
                responseObj.message = "Session Timed Out. Please restart the journey";
            }
        }
    }
    handleConfirmAccountLinking(response, responseObj) {
        if (response.statusCode === 200 || response.statusCode === 201) {
            responseObj.status = "SUCCESS";
        }
        else if (response.statusCode === 400) {
            switch (response.errorCode) {
                case 2330:
                    //Failed to get fip server response FIP server error
                    //responseObj.status = 'UNKNOWN_ERROR';
                    responseObj.status = "FAILURE";
                    responseObj.message = "Some error occurred, please try again after some time";
                    break;
                case 9050:
                    //Failed to get fip server response // TODO : retry the process
                    responseObj.status = "RETRY";
                    responseObj.message = "The asset linking process could not completed due to incorrect authentication credentials. Pls re-try again with correct details";
                    break;
                case 2335:
                    responseObj.status = "BAD_REQUEST";
                    responseObj.message = "Invalid Account link ref number";
                    break;
                case 8000:
                    responseObj.status = "SESSION_ERROR";
                    responseObj.message = "Session Timed Out. Please restart the journey";
                    break;
            }
        }
        else if (response.statusCode === 500) {
            if (response.errorCode === 500) {
                responseObj.status = "FAILURE";
                responseObj.message = "Some error occurred, please try again after some time";
            }
        }
    }
    handleConsentAction(response, responseObj) {
        if (response.statusCode === 200 || response.statusCode === 201) {
            responseObj.status = "SUCCESS";
        }
        else if (response.statusCode === 400) {
            switch (response.errorCode) {
                case 182:
                case 141:
                    //Failed to get fip server response Consent creation request failed
                    responseObj.status = "FAILURE";
                    //responseObj.message = 'Consent creation request failed';
                    responseObj.message = "Some error occurred, please try again after some time";
                    break;
                case 185:
                    responseObj.status = "BAD_REQUEST";
                    responseObj.message = "Invalid Consent accounts";
                    break;
                case 201:
                    responseObj.status = "BAD_REQUEST";
                    responseObj.message = "Consent Enddate is already over";
                    break;
                case 5002:
                    responseObj.status = "BAD_REQUEST";
                    responseObj.message = "Access Token should not be null";
                    break;
                case 100:
                    responseObj.status = "FAILURE";
                    responseObj.message = "Server error";
                    break;
                case 194:
                    //Failed to get fip server response TODO : retry 3
                    //responseObj.status = 'FAILURE';
                    responseObj.status = "RETRY";
                    responseObj.message = "Consent rejection failed";
                    break;
                case 8000:
                    responseObj.status = "SESSION_ERROR";
                    responseObj.message = "Session Timed Out. Please restart the journey";
                    break;
            }
        }
        else if (response.statusCode === 500) {
            if (response.errorCode === 500) {
                responseObj.status = "FAILURE";
                responseObj.message = "Some error occurred, please try again after some time";
            }
        }
        else if (response.statusCode === 401 || response.statusCode === 403) {
            if (response.errorCode === 401 || response.errorCode === 5000) {
                responseObj.status = "SESSION_ERROR";
                responseObj.message = "Session Timed Out. Please restart the journey";
            }
        }
    }
    handleUserInfo(response, responseObj) {
        if (response.statusCode === 200) {
            responseObj.status = "SUCCESS";
        }
        else if (response.statusCode === 500) {
            if (response.errorCode === 500) {
                responseObj.status = "FAILURE";
                responseObj.message = "Some error occurred, please try again after some time";
            }
        }
        else if (response.statusCode === 400) {
            switch (response.errorCode) {
                case 522:
                    responseObj.status = "BAD_REQUEST";
                    responseObj.message = "Invalid Customer Id";
                    break;
                case 8000:
                    responseObj.status = "SESSION_ERROR";
                    responseObj.message = "Session Timed Out. Please restart the journey";
                    break;
            }
        }
    }
    handleLogout(response, responseObj) {
        if (response.statusCode === 204 || response.statusCode === 200) {
            responseObj.status = "SUCCESS";
        }
    }
}
//# sourceMappingURL=ResponseMapperNadl.js.map